import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_inventory_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { paging?: { page: number, total: number }, warehouse: string, filters?: { owner?: string, project?: string, material?: string, lot?: string, vendor_lot?: string, upc?: string }, output_weight_uom?: string }): Promise<{ paging?: { total_records?: number, total_pages?: number, page?: number, returned_records?: number }, results?: any }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouse)) {
      $missingRequiredInParams.push('\'warehouse\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

